import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleOvertimeStopFirstHalftime extends DomainEvent<MatchEvent> {}
